var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoI(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.85,
    stroke: "#BF1E2E",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85866 13V5.90909H9.52983V13H7.85866ZM8.69886 4.9027C8.43419 4.9027 8.20644 4.81499 8.01562 4.63956C7.82481 4.46106 7.7294 4.24716 7.7294 3.99787C7.7294 3.7455 7.82481 3.5316 8.01562 3.35618C8.20644 3.17767 8.43419 3.08842 8.69886 3.08842C8.96662 3.08842 9.19437 3.17767 9.3821 3.35618C9.57292 3.5316 9.66832 3.7455 9.66832 3.99787C9.66832 4.24716 9.57292 4.46106 9.3821 4.63956C9.19437 4.81499 8.96662 4.9027 8.69886 4.9027Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoI);
export default __webpack_public_path__ + "static/media/infoI.339419f0fbbe2eb2ea7f439d97f977b3.svg";
export { ForwardRef as ReactComponent };